function hasValidFylkeInput(
  fylker: Array<number>,
  selectedAreaType: string | undefined
): boolean {
  return selectedAreaType === "fylker" && fylker.length > 0;
}

function hasValidKommuneInput(
  kommuner: Array<number>,
  selectedAreaType: string | undefined
): boolean {
  return selectedAreaType === "kommuner" && kommuner.length > 0;
}

interface hasValidAreaInputProps {
  fylker: Array<number>;
  kommuner: Array<number>;
  selectedAreaType: string | undefined;
}

export function hasValidAreaInput({
  fylker,
  kommuner,
  selectedAreaType
}: hasValidAreaInputProps): boolean {
  // Check if Område is choosen
  return (
    hasValidFylkeInput(fylker, selectedAreaType) ||
    hasValidKommuneInput(kommuner, selectedAreaType)
  );
}
